<template>
  <SkeletonItem
    :class="rootClasses"
    :style="rootStyles"
  />
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';
  import { computed } from 'vue';

  const props = defineProps<{
    skeletonClass?: string;
    width?: number | string;
    height?: number | string;
  }>();

  function styleToString(style?: number | string | null) {
    if (!style) {
      return undefined;
    }

    return typeof style === 'number' ? `${style}px` : style;
  }

  const rootClasses = computed(() => {
    return [props.skeletonClass, 'skeleton-radius'];
  });

  const rootStyles = computed(() => {
    const width = styleToString(props.width);
    const minWidth = width;
    const height = styleToString(props.height);

    return {
      width,
      minWidth,
      height,
    };
  });
</script>

<style lang="scss">
  .skeleton-radius {
    // TODO: формировать радиус по элементу
    border-radius: 8px;
  }
</style>
